import React from 'react';

const SolutionsSection = () => (
  <section className="solutions">
    <h3>Solutions we offer</h3>
    <div className="solutions-grid">
      {[
        { title: 'Strategic monitoring', image: '/solutions/01.png' },
        { title: 'Analytical solutions', image: '/solutions/02.png' },
        { title: 'Data quality management', image: '/solutions/03.png' },
        { title: 'Infrastructure management', image: '/solutions/04.png' },
      ].map((solution, index) => (
        <div key={index} className="solution-card">
          <img src={solution.image} alt={solution.title} />
          <h4>{solution.title}</h4>
        </div>
      ))}
    </div>
  </section>
);

export default SolutionsSection;